<template>
  <v-container>
    <div class="text-center background text border pt-2">
      <div class="mt-2">
        <h4>Select world</h4>
      </div>
      <div class="d-flex justify-content-center">
        <div class="mt-3" style="width: 60%">
          <v-select
            @change="selectedWorld"
            :items="worlds"
            label="Choose world..."
            solo
          ></v-select>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {  mapState, mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["selectedWorld"])
  },
  computed: {
    ...mapState(["worlds","worldSelected"])
  },
};
</script>

<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147);
}

.border {
  border-radius: 10px;
}
</style>